import React from 'react'

import { SvgProps } from './types'

interface Props extends SvgProps {
  upArrowColor?: string
  downArrowColor?: string
}

function ChevronUpDownSvg({
  width,
  height,
  className,
  size,
  styles,
  fill,
  rotate,
  stroke,
  upArrowColor,
  downArrowColor,
}: Props) {
  const { innerWidth } = window
  const defaultWidth = innerWidth > 1024 ? 's' : 'm'
  const sizeKey = typeof size === 'undefined' ? defaultWidth : size
  const rotateValue: 'left' | 'right' | 'top' | 'down' = rotate || 'left'

  const scale = {
    xl: 3.0,
    lg: 2.5,
    m: 1.0,
    s: 0.8,
    xs: 0.5,
  }

  const rotateDegrees = {
    left: '0deg',
    right: '180deg',
    top: '90deg',
    down: '270deg',
  }

  return (
    <svg
      className={className}
      style={{
        ...styles,
        ...{
          height: 'auto',
          transform: `rotate(${rotateDegrees[rotateValue]}) scale(${scale[sizeKey]})`,
        },
      }}
      width={width || 40}
      height={height || 40}
      xmlns="http://www.w3.org/2000/svg"
      fill={fill || 'none'}
      viewBox="0 0 12 12"
      stroke="currentColor"
      strokeWidth={stroke || '1.25'}
    >
      <path
        d="M8.5 4L6 1.5L3.5 4"
        stroke={upArrowColor || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 8L6 10.5L3.5 8"
        stroke={downArrowColor || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ChevronUpDownSvg
